import moment from "moment";

export const columns = [
  { accessorKey: "itemName", header: "Item Name", flex: 1 },
  {
    accessorKey: "vehicleNumber",
    header: "Vehicle",
    type: "string",
    size: 140,
  },

  {
    accessorKey: "warehouse",
    header: "Warehouse",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "importerName",
    header: "Importer",
    flex: 1,
    accessorFn: (row: any) => ` ${row.importerName || "-"}`,
  },
  {
    accessorKey: "exporterName",
    header: "Exporter",
    flex: 1,
    accessorFn: (row: any) => ` ${row.exporterName || "-"}`,
  },
  {
    accessorKey: "entryDate",
    header: "Check-in",
    flex: 1,
    accessorFn: function customCell(row: any) {
      return `${row.entryDate ? moment(row.entryDate).format("DD-MM-YYYY hh:mm:ss A") : "-"}`;
    },
  },
  { accessorKey: "entryReason", header: "Entry Reason", flex: 1 },
  { accessorKey: "inventoryStatus", header: "Status", flex: 1 },
  {
    accessorKey: "detainedByName",
    header: "Name",
    flex: 1,
    accessorFn: (row: any) => ` ${row.detainedByName || "-"}`,
  },
  {
    accessorKey: "detainedByDepartment",
    header: "Department",
    flex: 1,
    accessorFn: (row: any) => ` ${row.detainedByDepartment || "-"}`,
  },
  {
    accessorKey: "detainedByDesignation",
    header: "Designation",
    flex: 1,
    accessorFn: (row: any) => ` ${row.detainedByDesignation || "-"}`,
  },
];
